export const USER_CONSTANT = {
  UPDATE_PASSWORD_START: 'LI/USER-ACCOUNT/update-password/requested',
  UPDATE_PASSWORD_FAILED: 'LI/USER-ACCOUNT/update-password/failed',
  UPDATE_PASSWORD_SUCCESS: 'LI/USER-ACCOUNT/update-password/success',

  RESET_STATUS: 'LI/USER-ACCOUNT/reset-status',
  RESET_ALL: 'LI/USER-ACCOUNT/reset-all',
};
